export enum PolicyTypes {
    NONE = "none",
    TRUST_SCORE = "trustScore",
    ALWAYS_OBLIGATE = "alwaysObligation",
    ALWAYS_APPROVE = "alwaysApprove",
    ALWAYS_DENY = "alwaysDeny",
    CUSTOM = "custom",
    DECISION_ENGINE = "Decision Engine"
}
